// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.table-container {
    display: flex;
    justify-content: center;
    margin-top: 0px;
}

.view-survey-table {
    width: 100%;
    border-collapse: collapse;
}

.view-survey-table tr {
    display: flex;
    justify-content: space-between;
    margin-bottom: 4px;
    box-shadow: none;
    border-radius: 5px;
    margin-right: 2px;
    margin-left: 2px;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
}

.view-survey-table th,
.view-survey-table td {
    padding: 4px;
    text-align: left;
    flex: 1 1; 
    display: flex;
    align-items: center; 
}
.view-survey-table th:first-child,
.view-survey-table td:first-child {
  flex: 1 1;
}

.view-survey-table th:nth-child(2),
.view-survey-table td:nth-child(2) {
  flex: 5 1;
  
}
.view-survey-table th:nth-child(3),
.view-survey-table td:nth-child(3) {
  flex: 1.5 1;
}


.view-survey-table th {
    color: #3b454f;
    font-weight: 600;
    font-size: 1.125rem;
    border-bottom: 5px solid #102a62;
    box-shadow: none;
    background-color: transparent;
    align-items: center; 
}

.view-survey-table td {
    color: #3b454f;
    font-weight: 400;
}

.view-survey-table tr:hover {
    background-color: #f1f1f1;
}


/* Add this CSS to align the sort icon and labels */
.view-survey-table th div {
  display: flex;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/SurveyManagement/Table.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;;IAEI,YAAY;IACZ,gBAAgB;IAChB,SAAO;IACP,aAAa;IACb,mBAAmB;AACvB;AACA;;EAEE,SAAO;AACT;;AAEA;;EAEE,SAAO;;AAET;AACA;;EAEE,WAAS;AACX;;;AAGA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;IAChC,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA,mDAAmD;AACnD;EACE,aAAa;EACb,mBAAmB;AACrB","sourcesContent":["\n.table-container {\n    display: flex;\n    justify-content: center;\n    margin-top: 0px;\n}\n\n.view-survey-table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.view-survey-table tr {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 4px;\n    box-shadow: none;\n    border-radius: 5px;\n    margin-right: 2px;\n    margin-left: 2px;\n    border-top: 1px solid #ccc;\n    border-bottom: 1px solid #ccc;\n}\n\n.view-survey-table th,\n.view-survey-table td {\n    padding: 4px;\n    text-align: left;\n    flex: 1; \n    display: flex;\n    align-items: center; \n}\n.view-survey-table th:first-child,\n.view-survey-table td:first-child {\n  flex: 1;\n}\n\n.view-survey-table th:nth-child(2),\n.view-survey-table td:nth-child(2) {\n  flex: 5;\n  \n}\n.view-survey-table th:nth-child(3),\n.view-survey-table td:nth-child(3) {\n  flex: 1.5;\n}\n\n\n.view-survey-table th {\n    color: #3b454f;\n    font-weight: 600;\n    font-size: 1.125rem;\n    border-bottom: 5px solid #102a62;\n    box-shadow: none;\n    background-color: transparent;\n    align-items: center; \n}\n\n.view-survey-table td {\n    color: #3b454f;\n    font-weight: 400;\n}\n\n.view-survey-table tr:hover {\n    background-color: #f1f1f1;\n}\n\n\n/* Add this CSS to align the sort icon and labels */\n.view-survey-table th div {\n  display: flex;\n  align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
